import { cached, tracked } from "@glimmer/tracking";
import Controller, { inject as controller } from "@ember/controller";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { popupAjaxError } from "discourse/lib/ajax-error";
import { i18n } from "discourse-i18n";

export default class CirclesIndexController extends Controller {
  @service("circles") circlesService;
  @service currentUser;
  @service store;
  @service router;
  @controller application;

  @tracked filter = null;
  @tracked type = null;
  @tracked circles = null;
  @tracked isLoading = false;

  queryParams = [
    "filter",
    "type",
    ...this.circlesService.customFilters.map((filter) => {
      if (filter.type === "multiselect") {
        return {
          [filter.queryParameter]: {
            type: "array",
          },
        };
      }

      return filter.queryParameter;
    }),
  ];

  #username = null;

  get types() {
    return this.circles?.extras?.type_filters?.map((type) => ({
      id: type,
      name: i18n(`discourse_circles.index.types.${type}.title`),
      description: i18n(`discourse_circles.index.types.${type}.description`),
    }));
  }

  get isUserProfile() {
    return !!this.#username;
  }

  get isFilteringByTypeEnabled() {
    return this.types?.length > 0 && !this.isUserProfile;
  }

  get showNewCircleButton() {
    return (
      this.circlesService.userCanCreateCircles &&
      (!this.#username || this.currentUser.username === this.#username)
    );
  }

  @cached
  get filters() {
    return this.circlesService.customFilters;
  }

  async loadCircles(params) {
    this.isLoading = true;
    this.#username = params?.username;

    const serializedParams = Object.fromEntries(
      Object.entries(params).map(([key, value]) => {
        if (Array.isArray(value)) {
          return [key, JSON.stringify(value)];
        }
        return [key, value];
      })
    );

    try {
      this.circles = await this.store.findAll("circle", serializedParams);
    } catch (e) {
      popupAjaxError(e);
    } finally {
      this.isLoading = false;
    }
  }

  get totalRows() {
    return this.circles?.totalRows;
  }

  get hasCircles() {
    return this.circles?.content.length > 0;
  }

  @action
  loadMore() {
    this.circles && this.circles.loadMore();
  }

  @action
  newCircle() {
    this.router.transitionTo("circles.new");
  }
}
